/** Как чип меняет поле (§1.7): 'set' — готовый промпт заменяет текст, повторное нажатие очищает;
    'add' — текст чипа дописывается через запятую, повторное нажатие убирает его.
    Как chip() шаблона (assets/bot-core.js, BC.sc.chip): дописывается полный текст чипа со строчной буквы, отмечен — если текст уже
    есть в поле (без учёта регистра), убирается вместе с запятой перед ним. */
export type StudioChipMode = 'set' | 'add';

export function applyStudioChip(value: string, chip: string, mode: StudioChipMode): string {
  if (mode === 'set') return value === chip ? '' : chip;
  if (studioChipOn(value, chip, mode)) {
    const escaped = chip.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return value
      .replace(new RegExp('(,\\s*)?' + escaped, 'i'), '')
      .replace(/^[\s,]+/, '')
      .trim();
  }
  const base = value.trim().replace(/[\s,.;]+$/, '');
  return base ? `${base}, ${chip.charAt(0).toLocaleLowerCase('ru')}${chip.slice(1)}` : chip;
}
export function studioChipOn(value: string, chip: string, mode: StudioChipMode): boolean {
  if (mode === 'set') return value === chip;
  return !!chip && value.toLocaleLowerCase('ru').includes(chip.toLocaleLowerCase('ru'));
}
